// extracted by mini-css-extract-plugin
module.exports = {"required-asterisk":"styles_required-asterisk__37ebj"};